import { Box, Center } from "@chakra-ui/react";
import loaderEndingAnimation from "lotties/vault_splash.json";
import Lottie from "lottie-react";

type PageLoaderProps = {
  onLoopComplete?: () => void;
  loop?: boolean;
};

const PageLoader = ({
  onLoopComplete = () => {},
  loop = true,
}: PageLoaderProps) => {
  return (
    <Center
      position="absolute"
      width="100%"
      height="100vh"
      top={0}
      left={0}
      bg="#f4f4f7"
      zIndex={15}
    >
      <Box height={{ base: 200, md: 250 }} width={{ base: 200, md: 250 }}>
        <Lottie
          animationData={loaderEndingAnimation}
          loop={loop}
          onLoopComplete={onLoopComplete}
          autoplay={true}
        />
      </Box>
    </Center>
  );
};

export default PageLoader;
